import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Icon } from '@uhg-abyss/web/ui/Icon';

export const PageContainer = styled(Flex, {
  background: '#FAFCFF',
  height: '384px',
  gap: '12px',
  alignItems: 'center',
  alignContent: 'center',
  flexDirection: 'column',
  paddingBottom: '$md',
  '@media (max-width: 464px)': {
    height: '273px',
    paddingTop: '$md',
    paddingLeft: '$lg',
    alignContent: 'flex-start',
    flexDirection: 'row-reverse',
  },
});

export const IconContainer = styled('div', {
  height: '141px',
  width: '175px',
  overflow: 'hidden',
  position: 'relative',
  '@media (max-width: 464px)': {
    height: '173px',
    width: '128px',
  },
});

export const PageContent = styled(Flex, {
  alignContent: 'center',
  alignItems: 'center',
  flex: 1,
  flexDirection: 'column',
  '@media (max-width: 464px)': {
    alignItems: 'flex-start',
    alignContent: 'flex-start',
  },
});

export const BrokenLinkIcon = styled(Icon, {
  position: 'absolute',
  top: '-32px',
  width: '175px ! important',
  height: '173px! important',
  '@media (max-width: 464px)': {
    right: '-47px',
    top: 'unset',
  },
});
